import { render, staticRenderFns } from "./VBreadCrumb.vue?vue&type=template&id=db7a7170&scoped=true"
import script from "./VBreadCrumb.vue?vue&type=script&lang=js"
export * from "./VBreadCrumb.vue?vue&type=script&lang=js"
import style0 from "./VBreadCrumb.vue?vue&type=style&index=0&id=db7a7170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7a7170",
  null
  
)

export default component.exports